<footer class="footer fixed-bottom">
    <span class="mt-3">© {{todayDate | date: 'yyyy'}} {{'common.lblAllRights' | translate }} </span>
    <span class="pl-2 d-flex text-end mt-3">{{this._versionApp}}</span>
</footer>